<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row-start row-space">
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect :labelPeriodo="'Período de Contratação'" v-model="dateRange" /></div>
            
            <OsStatusSelect class="form-item" v-model:statusSelecionado="idStatus1" />
            <OsStatusSelect class="form-item" v-model:statusSelecionado="idStatus2" />

            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <div class="row row-space">
            <EquipamentoGrupoSelect :ckAddTodos="true" v-model:idSelecionado="idGrupo" v-model:objSelecionado="objEquipamentoGrupo"/>
            <EquipamentoSelect :ckAddTodos="true" :flagTipo="1" v-model:idSelecionado="idEquipamento" v-model:objSelecionado="objEquipamento" />
        </div>

        <div class="row row-space">
            <RegiaoSelect :ckAddTodos="true" v-model:idSelecionado="idRegiao" v-model:objSelecionado="objRegiao"/>
            <LocalidadeSelect :ckAddTodos="true" v-model:idSelecionado="idLocalidade" v-model:objSelecionado="objLocalidade"/>
            <ServicoSelect :ckAddTodos="true" v-model:idSelecionado="idServico" v-model:objSelecionado="objServico"/>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OsStatusSelect from '@/selects/estaticos/OsStatusSelect.vue';
import RegiaoSelect from '@/selects/RegiaoSelect.vue';
import ServicoSelect from '@/selects/ServicoSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const idEquipamento = ref(null);
const idGrupo = ref(null);
const idLocalidade = ref(null);
const idRegiao = ref(null);
const idServico = ref(null);
const idStatus1 = ref(null);
const idStatus2 = ref(null);
const msgAlerta = ref(null);
const isLoading = ref(false);

const objEquipamento = ref(null);
const objEquipamentoGrupo = ref(null);
const objLocalidade = ref(null);
const objRegiao = ref(null);
const objServico = ref(null);

const lsOpcoes = ref([
    {id: 'os_analitico_grupo', descricao: 'Grupo de Equipamento'},
    {id: 'os_analitico_regiao', descricao: 'Região'},
    {id: 'os_analitico_servico', descricao: 'Tipo de Serviço'},
]);
const opcaoSelecionada = ref('os_analitico_grupo');

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        let informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        if (objEquipamentoGrupo.value && objEquipamentoGrupo.value.id > 0) informacoes += `; Grupo: ${objEquipamentoGrupo.value.nmgrupo}`;
        if (objEquipamento.value && objEquipamento.value.id > 0) informacoes += `; Equipamento: ${objEquipamento.value.nmequipamento}`;
        if (objRegiao.value && objRegiao.value.id > 0) informacoes += `; Região: ${objRegiao.value.nmregiao}`;
        if (objLocalidade.value && objLocalidade.value.id > 0) informacoes += `; Localidade: ${objLocalidade.value.nmlocalidade}`;
        if (objServico.value && objServico.value.id>0) informacoes += `; Serviço: ${objServico.value.nmservico}`;

        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            idequipamento: idEquipamento.value,
            idequipamentogrupo: idGrupo.value,
            idlocalidade: idLocalidade.value,
            idregiao: idRegiao.value,
            idservico: idServico.value,
            informacoes,
            intp1: idStatus1.value,
            intp2: idStatus2.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>